import { FC } from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import cn from 'classnames';
import moment from 'moment';

import isBoolean from '@utils/isBoolean';

import { IFormDateProps } from './FormDate.interface';

import './styles.scss';

const FormDate: FC<IFormDateProps> = ({
  className,
  variant = 'filled',
  required,
  input: { onChange, value, ...otherInput },
  meta,
  InputProps = {},
  ...other
}) => (
  <DatePicker
    {...other}
    className={cn('form-date', className)}
    onChange={value => onChange(value ? value.format('YYYY-MM-DD') : null)}
    value={moment(value)}
    slotProps={{
      textField: {
        variant,
        helperText: meta.touched ? (isBoolean(meta.error) ? undefined : meta.error) : undefined,
        error: meta.error && meta.touched,
        inputProps: otherInput,
        required,
      },
    }}
  />
);

export default FormDate;
